import { type PortableTextBlock } from 'next-sanity'

import { Accordion } from '@/app/components/Accordion'
import { TRACKING_LOCATIONS } from '@/app/utils/analytics'
import type { FaqSection as FaqSectionProps } from '@/sanity.types'

type FaqSectionComponentProps = {
  block: FaqSectionProps & { _key?: string }
  index: number
  pageId?: string
  pageType?: string
}

export default function FaqSection({ block, index, pageId, pageType }: FaqSectionComponentProps) {
  if (!block?.heading || !block?.faqs || block.faqs.length === 0) return null

  return (
    <div className="content-container my-8xl lg:my-12xl">
      <div className="flex flex-col gap-9xl max-w-[1144px] mx-auto lg:flex-row">
        <p className="size-header-h3 text-neutral-950 text-center lg:text-left lg:font-normal lg:w-[270px] lg:shrink-0 xl:w-[400px] xl:size-header-h1">
          {block.heading}
        </p>
        <div className="flex flex-col gap-2xl lg:flex-1">
          {block.faqs.map((faq, faqIndex) => {
            if (!faq?.heading || !faq?.content) return null
            return (
              <Accordion
                key={faq._key || faqIndex}
                value={{
                  heading: faq.heading as PortableTextBlock[],
                  content: faq.content as PortableTextBlock[],
                }}
                tracking={{ location: TRACKING_LOCATIONS.PAGE_CONTENT }}
                documentId={pageId}
                documentType={pageType}
                parentPath={
                  block._key ? `pageBuilder[_key=="${block._key}"].faqs[${faqIndex}]` : undefined
                }
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}
